import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import GraphConfigForm from '../../SuperAdmin/DashboardGraphConfig/GraphConfigForm';

const GraphConfigEditModal = ({ show, graphConfig, standardId, onClose, onSaved }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onClose} size="xl" backdrop="static" scrollable centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('EditConfig.label')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {show && graphConfig && (
          <GraphConfigForm
            embedded
            companyMode
            graphConfig={graphConfig}
            standardId={standardId}
            onCancel={onClose}
            onSaved={onSaved}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

GraphConfigEditModal.propTypes = {
  show: PropTypes.bool.isRequired,
  graphConfig: PropTypes.object,
  standardId: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired
};

export default GraphConfigEditModal;
